<template>
  <div id="selected-flights-pop-up" class="selected-flights-pop-up">
    <div class="default-pop-up-center-div center bordered" :class="{ blur: isBlurred }">
      <div class="selected-product-pop-up__container">
        <div>
          <div class="selected-product-pop-up__header">
            <div>
              <span class="h1">{{ flightName }}</span>
            </div>
          </div>

          <div class="flight-items-container">
            <div class="bundle-details">
              <b>Bundle Details</b>
            </div>
            <div class="padded control-buttons">
              <BaseBtn :disabled="isReducible || isEditDisabled" iconGroup="fas" iconName="minus" @click="reduce"
                :colorType="1" size="sm" />

              <BaseInput placeholder="Quantity" v-model="selectedQuantity" @focus="setFocus" :applyFocus="true"
                controlType="number" ref="quantity" :disabled="isEditDisabled" />

              <BaseBtn :disabled="isEditDisabled" iconGroup="fas" iconName="plus" @click="increase" size="sm" />
            </div>
          </div>

          <div class="flight-items-container">
            <div class="flight-items">
              <div v-for="item in flightItems" :key="item._id" class="flight-item">
                <div class="flight-item-name">
                  <div class="">{{ item.product.name }}</div>
                  <div class=""> {{
                    new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(item.lineTotal)
                  }}</div>
                </div>
                <div class="flight-item-detail">
                  <div class="text-color-1 text-thin">{{ getFlightItemDetail(item) }}</div>
                  <div class="text-color-1 text-thin"><span class="flight-discount-text">Discount: {{
                    new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(item.discount)
                  }}</span> | Quantity: {{ item.quantity * selectedQuantity }}</div>
                </div>
              </div>
              <div class="flight-item flight-item-total">
                <div class="flight-discount-text">Discount: {{
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(flightTotalDiscount)
                }}</div>
                <div class="">Total: {{
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(Math.round(flightItems.reduce((acc, item) => acc + item.lineTotal, 0) * selectedQuantity))
                }}</div>
              </div>
            </div>
            <div v-if="!isEditDisabled" class="desktop-only-block">
              <Keypad class="instant__keypad" :input="input" />
            </div>
          </div>
        </div>
      </div>
      <div class="padded button-wrapper">
        <BaseBtn :disabled="orderLoadingStatus.addRemoveItemToOrder || isRemoveDisabled" label="Remove" @click="confirmDeleteItem"
          :colorType="1" />
        <BaseBtn :disabled="orderLoadingStatus.addRemoveItemToOrder" @click="close" label="Close" :colorType="3" />
        <BaseBtn @click="submit" label="Submit" :disabled="isSubmittable ||
          orderLoadingStatus.addRemoveItemToOrder ||
          isEditDisabled
          " :isLoading="orderLoadingStatus.addRemoveItemToOrder" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Configuration from "@/resources/Configuration";
import Utilities from "@/lib/Utilities";
import BaseBtn from "@/components/Base/Button/Button.vue";
import BaseInput from "@/components/Base/Input/Base.vue";
import Keypad from "@/components/Keypad";

export default {
  name: "FlightsPopUp",
  data() {
    return {
      input: {},
      Utilities: Utilities,
      selectedQuantity: 1,
      product: {
        quantity: 0,
        availableQuantity: 0,
        product: { items: [] },
      },
      currentQuantity: 0,
      forcedItem: undefined,
      isBlurred: false,
    };
  },
  created: function () {
    window.addEventListener(
      "keyup",
      function (e) {
        if (e.keyCode === 27) {
          this.setSelectedFlightsPopUp({ isOpen: false });
        }
      }.bind(this)
    );
  },
  components: {
    BaseBtn,
    BaseInput,
    Keypad,
  },
  computed: {
    ...mapGetters({
      selectedFlightsPopUp: "posModule/selectedFlightsPopUp",
      flights: "flightModule/flights",
      loadingStatus: "flightModule/loadingStatus",
      order: "orderModule/order",
      currentStore: "storeModule/currentStore",
      orderLoadingStatus: "orderModule/loadingStatus",
    }),
    flightName() {
      return this.selectedFlightsPopUp?.selectedFlight?.name || "Bundle";
    },
    flightItems() {
      return this.selectedFlightsPopUp?.selectedFlight?.items || [];
    },
    flightTotalDiscount() {
      return (this.selectedFlightsPopUp?.selectedFlight?.discountTotal || 0) * this.selectedQuantity;
    },
    isReducible() {
      if (this.selectedQuantity <= 1) {
        return true;
      }
      return false;
    },
    isForcedFlight() {
      return this.selectedFlightsPopUp?.forcedFlightId;
    },
    isRemoveDisabled() {
      return this.currentQuantity <= 0;
    },
    isSubmittable() {
      return this.selectedQuantity <= 0;
    },
    isEditDisabled() {
      return (
        !this.currentStore.isShowQuantityBoxEnabled
      );
    },
  },
  mounted() {
    if (this.isForcedFlight) {
      this.getFlightById({
        _id: this.selectedFlightsPopUp?.forcedFlightId,
        positiveCallback: flight => {
          this.selectedFlightsPopUp.selectedFlight = flight;
          this.calculateCurrentQuantity();
        }
      });
    }
  },
  methods: {
    ...mapActions({
      setSelectedFlightsPopUp: "posModule/setSelectedFlightsPopUp",
      addRemoveItemToCart: "posModule/addRemoveItemToCart",
      setMessage: "posModule/setMessage",
      setMessagePopUp: "setMessagePopUp",
      addRemoveFlightToOrder: "orderModule/addRemoveFlightToOrder",
      getFlightById: "flightModule/getFlightById",
    }),
    setFocus(e) {
      this.input = e.target;
    },
    reduce: function () {
      this.selectedQuantity -= 1;
    },
    increase: function () {
      this.selectedQuantity += 1;
    },
    getFlightItemDetail: function (item) {
      return (item.group?.name || ' - ') + " | " + (item?.supplier?.name || ' - ');
    },
    close: function () {
      this.setSelectedFlightsPopUp({ isOpen: false });
    },
    calculateCurrentQuantity: function () {
      const orderItemsWithFlight = this.selectedFlightsPopUp.order.flightsApplied.filter(f => f.flightId.toString() == this.selectedFlightsPopUp.selectedFlight._id.toString())
      if (orderItemsWithFlight.length > 0) {
        const quantity = orderItemsWithFlight[0].quantity;
        this.currentQuantity = quantity;
        this.selectedQuantity = quantity;
      }
    },
    submit: function () {
      this.isBlurred = true;
      const difference = this.selectedQuantity - this.currentQuantity;
      console.log(difference, this.selectedQuantity, this.currentQuantity)
      if (difference > 0) {
        this.addRemoveFlightToOrder({
          action: {
            mode: "add",
            quantity: Math.abs(difference),
            flightId: this.selectedFlightsPopUp.selectedFlight._id,
          },
          positiveCallback: (order) => {
            // this.updateQuantity(order);
            // this.selectedFlightsPopUp.positiveCallback();
            this.setSelectedFlightsPopUp({ isOpen: false });
          },
          negativeCallback: () => {
            this.isBlurred = false;
          },
        });
      }
      else if (difference < 0) {
        this.addRemoveFlightToOrder({
          action: {
            mode: "subtract",
            quantity: Math.abs(difference),
            flightId: this.selectedFlightsPopUp.selectedFlight._id,
          },
          positiveCallback: (order) => {
            // this.updateQuantity(order);
            // this.selectedFlightsPopUp.positiveCallback();
            this.setSelectedFlightsPopUp({ isOpen: false });
          },
          negativeCallback: () => {
            this.isBlurred = false;
          },
        });
      }
      else {
        this.setSelectedFlightsPopUp({ isOpen: false });
      }
    },
    confirmDeleteItem: function () {
      this.isBlurred = true;
      this.setMessagePopUp({
        isOpen: true,
        title: "Warning!",
        message: "Do you really want to remove this item from the cart?",
        positiveCallback: this.performDeleteItem,
        negativeCallback: () => {
          this.isBlurred = false;
        },
      });
    },
    performDeleteItem: function () {
      this.addRemoveFlightToOrder({
        action: {
          mode: "remove",
          quantity: this.selectedQuantity,
          flightId: this.selectedFlightsPopUp.selectedFlight._id,
        },
        positiveCallback: (order) => {
          // this.updateQuantity(order);
          // this.selectedFlightsPopUp.positiveCallback();
          this.setSelectedFlightsPopUp({ isOpen: false });
        },
        negativeCallback: () => {
          this.isBlurred = false;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.quantity-number {
  min-width: 50px;
}

.button-wrapper {
  display: flex;
  gap: 10px;
  width: 100%;

  &>button {
    width: 50%;
  }
}

.control-buttons {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0;
}

.details {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.selected-flights-pop-up {
  &__header {
    padding-bottom: 5px;
    width: 100%;
  }

  &__header-subtitle {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: $text-size-2;
    gap: 5px;
  }

  &__container {
    display: flex;
    gap: 1rem;
  }

  &__keypad {
    @include respond(tab-port) {
      display: none;
    }
  }
}

.batch-label {
  font-size: $text-size-2;
  color: gray;
}

.flight-items-container {
  display: flex;
  flex-direction: row;
  gap: 5rem;
}

.flight-items {
  width: 40rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.light .flight-items {
  border-top: 1px solid rgba($light-accent-color, 0.2);
  background: rgba($light-accent-color, 0.04);
}

.flight-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 1.2em;
  background-color: $dark-elevated-0;
  // color: rgba($dark-accent-color, 0.8);
}

.flight-item-name {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 1em;
}

.flight-item-detail {
  display: flex;
  justify-content: space-between;
  font-size: .8em;
}

.flight-item-total {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  background-color: rgba($dark-accent-color, 0.1);
  color: $dark-accent-color;
}

.light .flight-item-total {
  background-color: rgba($light-accent-color, 0.1);
  color: $light-accent-color;
}

.bundle-details {
  flex-grow: 1;
  width: 100%;
  font-size: 1.2em;
  font-weight: bold;
  text-align: start;
  align-self: flex-end;
  padding-bottom: 1rem;
}

.flight-discount-text {
  color: #f39c12;
}
</style>
